<template>
  <a :href="href" class="btn route-button col-xl-3 col-md-5 col-12">
    {{ text }}
  </a>
</template>

<script>
export default {
  name: 'HomeRouteButton',
  props: {
    href: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
  },
};
</script>
<style scoped lang="scss">
.route-button {
  display: inline-block;
  padding: 12px 25px;
  margin: 10px;
  border: none;
  color: black;
  text-decoration: none;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  transition: all 0.5s ease-in-out;  
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
  background: linear-gradient(45deg, #27884F 0% 85%, #26a06d 85% 100%);
  &:hover {
    animation: hoverEffect 0.5s ease-in-out forwards;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.3);
    background: linear-gradient(45deg, #27884F 0% 85%, #81e033 85% 100%);
  }
}
@keyframes hoverEffect {
  0% {
    transform: scale(1);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
  }
  100% {
    transform: scale(1.05);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
  }
}
@media (max-width: 576px) {
  .route-button {
    padding: 10px 20px;
    font-size: 0.9rem;
  }
}
</style>
  